// Ordered problems first: the detail lists the items in this order.
export const FINANCING_ENDING_OPERATION_ITEM_RESULT = {
  NOT_DELIVERED: 'NOT_DELIVERED',
  BLOCKED: 'BLOCKED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
  PENDING: 'PENDING',
  SENT: 'SENT',
} as const;

export type FinancingEndingOperationItemResult =
  (typeof FINANCING_ENDING_OPERATION_ITEM_RESULT)[keyof typeof FINANCING_ENDING_OPERATION_ITEM_RESULT];
